<div class="page">
    <div class="page-single">
        <div class="container">
            <div class="row">
                <div class="col col-login mx-auto">
                    <div class="text-center mb-6">
                        <img src="./assets/images/logo.png" class="h-6" alt="">
                    </div>
                    <form class="card" [formGroup]="forgetPasswordForm" (submit)="forgetPassword()">
                        <div class="card-body p-6">
                            <div class="card-title">Forget Password</div>
                            <div class="form-group">
                                <label class="form-label">Email</label>
                                <input type="text" class="form-control" formControlName="email" placeholder="Enter Email">
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                    <div *ngIf="f.email.errors.required">Email is required</div>
                                </div>
                                <div *ngIf="submitted && !f.email.valid" class="invalid-feedback">
                                    <div *ngIf="!f.email.valid && f.email.value">Email format is Invalid</div>
                                </div>
                            </div>
                            
                            <div class="form-footer">
                                <button type="submit" class="btn btn-primary" [disabled]="loading"><i class="fas fa-spin fa-spinner" *ngIf="loading"></i> Submit</button>
                                <a href="/login" class="float-right small">Back to Login</a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>